<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
                  <!-- <pre v-if="isDev" class="form-debug">{{ form }}</pre> -->
          <main class="container donation-torah outorah-donate-form donation-torah--general">
            <div class="form-main">
              <section class="form-section">
                <div>
                  <div class="contribution-type">
                    <FormLabel for="contribution-sponsorship">
                      <input
                        id="contribution-sponsorship"
                        type="radio"
                        name="contributionType"
                        :checked="!isCustomContribution"
                        @click="selectContributionType('sponsorship')"
                      />
                      Your Sponsorship
                    </FormLabel>
                    <FormLabel for="contribution-custom">
                      <input
                        id="contribution-custom"
                        type="radio"
                        name="contributionType"
                        :checked="isCustomContribution"
                        @click="selectContributionType('custom')"
                      />
                      Custom Contribution
                    </FormLabel>
                  </div>
                  <!-- <header>
                    <h4>{{ isCustomContribution ? 'Custom Contribution' : 'Your Sponsorship' }}</h4>
                  </header> -->
                  <div class="form__field">
                    <div v-if="isCustomContribution" class="custom-amount">
                      <p>Select amount</p>
                      <AmountSelector
                        :includeOther="true"
                        defaultCheckedAount="18"
                        amountText="Amount"
                      />
                      <ErrorLabel field="amount" />
                    </div>
                    <FormRow>
                      <FormLabel class="control-label control-label">
                        <b>Program Designation:</b>
                      </FormLabel>
                    </FormRow>
                    <div v-if="isCustomContribution" class="series__type">
                      <select
                        class="program-designation-select"
                        :value="selectedCustomProgram"
                        @change="selectCustomProgramByEvent"
                      >
                        <option v-for="program in customPrograms" :key="program.value" :value="program.value">
                          {{ program.label }}
                        </option>
                      </select>
                    </div>
                    <div v-else class="series__type">
                      <FormLabel for="generald" name="program">
                        <input
                          id="generald"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'General Donation'"
                          @click="setValue('custom.seriesType', 'General Donation'); setValue('custom.programId', null); setValue('amount', '250'); setValue('custom.sponsorshipType', 'day'); setValue('custom.dailyEmail', null)"
                        />
                        General Donation - <span style=" font-style: italic; color: #6b6b6b; font-weight: 100; ">(Dedication Not Displayed)</span>
                      </FormLabel>
                      <FormLabel for="dafg" name="program">
                        <input
                          id="dafg"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'Daf Yomi'"
                          @click="setValue('custom.seriesType', 'Daf Yomi'); setValue('custom.programId', null); setValue('amount', '250'); setValue('custom.sponsorshipType', 'day'); setValue('custom.dailyEmail', null)"
                        />
                        Daf Yomi
                      </FormLabel>
                      <FormLabel
                        v-for="(serie, index) in series"
                        :for="`type${index}`"
                        name="program"
                        :key="serie.id"
                      >
                        <input
                          :id="`type${index}`"
                          name="program"
                          type="radio"
                          @click="setValue('custom.seriesType', serie.name); setValue('custom.donationEmail', serie.donationEmail); setValue('custom.programId', serie.id.toString()); setValue('amount', '250'); setValue('custom.sponsorshipType', 'day'); setValue('custom.dailyEmail', null)"
                        />
                        {{ serie.displayName || serie.name }}
                      </FormLabel>
                      <div class="email__label">Daily Email Sponsorship ($180):</div>
                      <FormLabel for="newsletteremail" name="program">
                        <input
                          id="newsletteremail"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'Nach Yomi Daily Email'"
                          @click="setValue('custom.seriesType', 'Nach Yomi Daily Email'); setValue('custom.programId', null); setValue('amount', '180'); setValue('custom.sponsorshipType', 'day')"
                        />
                        Nach Yomi Daily Email
                      </FormLabel>
                      <FormLabel for="newsletteremailhashone" name="program">
                        <input
                          id="newsletteremailhashone"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'HaShoneh Halachos Daily Email'"
                          @click="setValue('custom.seriesType', 'HaShoneh Halachos Daily Email'); setValue('custom.programId', null); setValue('amount', '180'); setValue('custom.sponsorshipType', 'day')"
                        />
                        HaShoneh Halachos Daily Email
                      </FormLabel>
                      <FormLabel for="newsletteremailmishnayomit" name="program">
                        <input
                          id="newsletteremailmishnayomit"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'Mishna Yomit Daily Email'"
                          @click="setValue('custom.seriesType', 'Mishna Yomit Daily Email'); setValue('custom.programId', null); setValue('amount', '180'); setValue('custom.sponsorshipType', 'day')"
                        />
                        Mishna Yomit Daily Email
                      </FormLabel>
                      <FormLabel for="newsletteremailShnayimMikra" name="program">
                        <input
                          id="newsletteremailShnayimMikra"
                          name="program"
                          type="radio"
                          :checked="getValue('custom.seriesType') === 'Shnayim Mikra Daily Email'"
                          @click="setValue('custom.seriesType', 'Shnayim Mikra Daily Email'); setValue('custom.programId', null); setValue('amount', '180'); setValue('custom.sponsorshipType', 'day')"
                        />
                        Shnayim Mikra Daily Email
                      </FormLabel>
                    </div>
                    <FormRow v-if="!isCustomContribution">
                      <FormLabel class="control-label">
                        <b>Donation Amount:</b>
                      </FormLabel>
                    </FormRow>

                    <div
                      class="doantion__dates"
                      v-if="
                        !isCustomContribution &&
                        getValue('custom.seriesType') !== 'Nach Yomi Daily Email' &&
                        getValue('custom.seriesType') !==
                          'HaShoneh Halachos Daily Email' &&
                        getValue('custom.seriesType') !== 'Mishna Yomit Daily Email' &&
                        getValue('custom.seriesType') !== 'Shnayim Mikra Daily Email'
                      "
                    >

                    <!-- torha only -->
                      <div v-if="getValue('custom.seriesType') == 'General Donation'">

                        <div class="styled-radio-container--ou-donation type-selector">
                        <FormLabel for="donationShiurType-day">
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-day"
                            @click="setValue('custom.sponsorshipType', 'day')"
                            :checked="getValue('custom.sponsorshipType') == 'day'"
                          />
                          $250 per day listing
                        </FormLabel>

                        <FormLabel for="donationShiurType-week">
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-week"
                            @click="setValue('custom.sponsorshipType', 'week')"
                            :checked="getValue('custom.sponsorshipType') == 'week'"
                          />
                          $1,000 1 week listing
                        </FormLabel>
                        <FormLabel for="donationShiurType-month">
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-month"
                            @click="setValue('custom.sponsorshipType', 'month')"
                            :checked="getValue('custom.sponsorshipType') == 'month'"
                          />
                          $3,600 1 month listing
                        </FormLabel>
                      </div>                        
                      </div>
                      <div v-else>
                      <div class="styled-radio-container--ou-donation type-selector">
                        <FormLabel for="donationShiurType-day">
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-day"
                            @click="setValue('custom.sponsorshipType', 'day')"
                            :checked="getValue('custom.sponsorshipType') == 'day'"
                          />
                          $250 per day
                        </FormLabel>

                        <FormLabel for="donationShiurType-week">
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-week"
                            @click="setValue('custom.sponsorshipType', 'week')"
                            :checked="getValue('custom.sponsorshipType') == 'week'"
                          />
                          $1,000 1 week
                        </FormLabel>
                        <FormLabel 
                          v-if="getValue('custom.seriesType') !== 'Torat Imecha Nach Yomi'"
                          for="donationShiurType-month"
                        >
                          <input
                            type="radio"
                            name="donationShiurType"
                            id="donationShiurType-month"
                            @click="setValue('custom.sponsorshipType', 'month')"
                            :checked="getValue('custom.sponsorshipType') == 'month'"
                          />
                          $3,600 1 month
                        </FormLabel>
                      </div>
                    </div>

                      <ErrorLabel field="amount" />
                      <ErrorLabel field="custom.sponsorshipType" />
                    </div>
                    <div v-else-if="!isCustomContribution">
                      $180
                      <div class="note">
                        Please note that a minimum of 48 hours advance notice is required.
                      </div>
                    </div>
                    <br />

                    <FormRow v-if="!isCustomContribution">
                      <FormLabel class="control-label" style="max-width: 100%">
                        Date you would like to Sponsor
                      </FormLabel>
                    </FormRow>

                    <div v-if="!isCustomContribution" class="donation-type">
                      <FormRow
                        inline
                        style="max-width: 50%; margin-bottom: 10px"
                        v-if="getValue('custom.sponsorshipType') == 'week'"
                      >
                        <input
                          type="date"
                          class="date-input"
                          @change="setDate(new Date($event.target.value))"
                        />
                      </FormRow>
                      <FormRow
                        inline
                        style="max-width: 50%; margin-bottom: 10px"
                        v-else-if="getValue('custom.sponsorshipType') == 'month'"
                      >
                        <input
                          type="date"
                          class="date-input"
                          @change="setMonthDate(new Date($event.target.value))"
                        />
                      </FormRow>
                      <FormRow
                        inline
                        style="max-width: 50%; margin-bottom: 10px"
                        v-else-if="getValue('custom.sponsorshipType') == 'day'"
                      >
                        <input
                          v-if="
                            getValue('custom.seriesType') !== 'Nach Yomi Daily Email' &&
                            getValue('custom.seriesType') !==
                              'HaShoneh Halachos Daily Email' &&
                            getValue('custom.seriesType') !==
                              'Mishna Yomit Daily Email' &&
                            getValue('custom.seriesType') !== 'Shnayim Mikra Daily Email'
                          "
                          type="date"
                          class="date-input"
                          @change="setdayDate(new Date($event.target.value))"
                        />
                        <input
                          v-else
                          type="date"
                          class="date-input"
                          @change="setdayDate(new Date($event.target.value))"
                        />
                      </FormRow>
                      <ErrorLabel field="custom.startDate" />
                    </div>

                    <div class="form-group form-group--inline" style="">
                      <div>
                        <FormRow inline>
                <FormCol field="custom.dedicationMessage" width="full" :showLabel="false">
                  <label class="control-label" style="max-width: 100%">Dedicate your gift in honor of or in memory of a loved
                          one</label>
                  <FormInput type="text" />
                  <div class="sub__label">
                            Please enter the dedication/message that you would like to
                            appear/be announced
                          </div>                  
                </FormCol>
              </FormRow>
                      </div>
                    </div>
                    <div v-if="!isCustomContribution" class="form-group form-group--inline" style="">
                      <div
                        v-if="
                          form.amount &&
                          Number(form.amount) &&
                          Number(form.amount) > 999 &&
                          getValue('custom.seriesType') !== 'Nach Yomi Daily Email' &&
                          getValue('custom.seriesType') !==
                            'HaShoneh Halachos Daily Email' &&
                          getValue('custom.seriesType') !== 'Mishna Yomit Daily Email' &&
                          getValue('custom.seriesType') !== 'Shnayim Mikra Daily Email'
                        "
                      >
                        <FormRow inline>
                          <FormLabel>
                            <input
                              type="checkbox"
                              :checked="amudei"
                              @click="setValue('custom.amudei', !amudei)"
                            />
                            Would you like to join Amudei All Torah?
                          </FormLabel>
                        </FormRow>
                        <ErrorLabel field="custom.amudei" />
                      </div>
                    </div>

                    <FormRow>
                      <FormLabel class="control-label"> Special Instructions </FormLabel>
                    </FormRow>
                    <FormRow>
                      <FormInput
                        type="textarea"
                        class="width-full"
                        field="custom.comments"
                      />
                    </FormRow>
                  </div>
                </div>
              </section>
              <section class="form-section">
                <header>
                  <h4>Your contact information</h4>
                </header>
                <div class="form__field">
                  <FormRow inline>
                    <FormCol field="title" :flex="1" />
                    <FormCol field="firstName" :flex="2" />
                    <FormCol field="lastName" :flex="2" />
                  </FormRow>
                  <FormRow inline>
                    <FormCol field="email" />
                    <FormCol field="phone" />
                  </FormRow>
                  <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>  
                </div>
              </section>
              <section class="form-section">
                <header>
                  <h4>Billing Information</h4>
                </header>
                <div class="form__field">
                  <DonorAddress />
                </div>
              </section>
              <section class="form-section">
                <header>
                  <h4>Payment Information</h4>
                </header>
                <div class="form__field">
                  <FormRow>
                    <Receipt :receipts="['us', 'israel', 'canadian']" />
                  </FormRow>
               <br>
                  <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                  </FormRow>
                </div>
              </section>
              <PaymentButton showAmount btnText="Donate" />
            </div>
            <section class="form-sidebar">
              <div class="sidebar-sticky">
                <div class="form-section">
                  <header><h4>Your Summary</h4></header>
                  <div class="form-row form-row--line">
                    {{ isCustomContribution ? 'Custom Contribution' : 'Your Sponsorship' }}
                      <ul>
                        <li v-if="getValue('custom.seriesType')">
                          Program - <span>{{ seriesDisplayName }}</span>
                          <span v-if="getValue('custom.seriesType') == 'General Donation'" style=" display: block; font-style: italic; ">
                          Dedication Not Displayed
                        </span>

                      </li>
                      <li v-if="form.amount">
                        Donation Amount - <span>${{ form.amount }}</span>
                      </li>
                      <li v-if="getValue('custom.sponsorshipType')">
                        Donation Timespan -
                        <span>{{ getValue("custom.sponsorshipType") }}</span>
                      </li>
                      <li v-if="
                          !isCustomContribution &&
                          getValue('custom.sponsorshipType') &&
                          getValue('custom.startDate')
                        "
                      >
                        Donation Date -
                        {{ new Date(getValue("custom.startDate")).toLocaleDateString() }}
                        -
                        {{ new Date(getValue("custom.endDate")).toLocaleDateString() }}
                      </li>
                      <li v-if="getValue('custom.dedicationMessage')">
                        Dedicated in honor -
                        <span>{{ getValue("custom.dedicationMessage") }}</span>
                      </li>
                      <li v-if="getValue('custom.comments')">
                        Special Instructions-
                        <span>{{ getValue("custom.comments") }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  ref,
  defineComponent,
  onMounted,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup(props) {
    const { setValue, getValue, form, submit, testMode } = usePaymentForm();
    const isDev = import.meta.dev
    const series = ref([] as any[]);
    const selectedCustomProgram = ref("General Donation");
    const customPrograms = [
      { value: "General Donation", label: "General Donation", department: "OU_Torah", campaign: "General Donation" },
      { value: "Torat Imecha Nach Yomi", label: "Torat Imecha Nach Yomi from the OU Women's Initiative", department: "WomensInitative", campaign: "Torat Imecha", subCampaign: "Via OUTorah" },
      { value: "Daf Yomi", label: "Daf Yomi", department: "OU_Torah", campaign: "All Daf" },
      { value: "Nach Yomi", label: "The OU's Shoshana Grossman Nach Yomi", department: "OU_Torah", campaign: "General Donation", subCampaign: "Nach Yomi" },
      { value: "Daf Yomi with Rabbi Rosner", label: "Daf Yomi with Rabbi Rosner", department: "OU_Torah", campaign: "General Donation", subCampaign: "Daf Yomi with Rabbi Rosner" },
      { value: "Rabbi Shalom Rosner on The Parsha", label: "Rabbi Shalom Rosner on The Parsha", department: "OU_Torah", campaign: "General Donation", subCampaign: "Rabbi Shalom Rosner on The Parsha" },
    ];

    const amudei = computed(() => getValue("custom.amudei"));
    const isCustomContribution = computed(() => getValue("custom.contributionType") === "custom");

    function selectContributionType(type: "sponsorship" | "custom") {
      setValue("custom.contributionType", type);
      if (type === "custom") {
        setValue("custom.seriesType", customPrograms[0].value);
        selectCustomProgram(customPrograms[0]);
        setValue("amount", "18");
        setValue("custom.startDate", null);
        setValue("custom.endDate", null);
        setValue("custom.amudei", null);
      } else {
        selectedCustomProgram.value = "General Donation";
        setValue("custom.seriesType", "General Donation");
        setValue("custom.programId", null);
        setValue("applications.0.department", "OU_Torah");
        setValue("applications.0.campaign", "General Donation");
        setValue("applications.0.subCampaign", null);
        setValue("amount", "250");
        setValue("custom.sponsorshipType", "day");
      }
    }

    function selectCustomProgram(program: typeof customPrograms[number]) {
      selectedCustomProgram.value = program.value;
      setValue("custom.seriesType", program.value);
      setValue("custom.programId", null);
      setValue("applications.0.department", program.department);
      setValue("applications.0.campaign", program.campaign);
      setValue("applications.0.subCampaign", program.subCampaign || null);
      setValue("custom.sponsorshipType", null);
      setValue("custom.dateOption", null);
    }

    function selectCustomProgramByValue(value: string) {
      const program = customPrograms.find((item) => item.value === value);
      if (program) selectCustomProgram(program);
    }

    function selectCustomProgramByEvent(event: Event) {
      selectCustomProgramByValue((event.target as HTMLSelectElement).value);
    }

    setValue(
      "callback",
      testMode
        ? "https://admin-outorah.oudev.org/outorahDonationCallback"
        : "https://admin.outorah.org/outorahDonationCallback"
    );

    const layout = ref(true);
    // setValue("amount", "3600");
    // setValue("custom.sponsorshipType", "month");
    setValue("custom.seriesType", "General Donation");
    setValue("custom.contributionType", "sponsorship");
    setValue("custom.dateOption", "Month");
    setValue("custom.programId", null);
    setValue("custom.dafType", null);

    watch(
      () => getValue("custom.seriesType"),
      () => {
        if (isCustomContribution.value) return;
        if (getValue("custom.seriesType") == "Daf Yomi") {
          setValue("custom.dafType", "daf");
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "All Daf");

          watch(
            () => getValue("custom.sponsorshipType"),
            () => {
              if (isCustomContribution.value) return;
              if (getValue("custom.sponsorshipType") == "week") {
                setValue("amount", "1000");
                setValue("custom.dateOption", "Week");
              } else if (getValue("custom.sponsorshipType") == "month") {
                setValue("amount", "3600");
                setValue("custom.dateOption", "Month");
              } else if (getValue("custom.sponsorshipType") == "day") {
                setValue("amount", "250");
                setValue("custom.dateOption", "Day");

                // setValue("custom.seriesType", null);
              } else {
                setValue("amount", "3600");
                setValue("custom.sponsorshipType", "month");
                setValue("custom.seriesType", "General Donation");
                setValue("custom.dateOption", "Month");
                setValue("custom.programId", null);
              }
            }
          );
        } else if (
          getValue("custom.seriesType") == "Torat Imecha Nach Yomi" ||
          getValue("custom.seriesType") == "Torat Imecha Parsha"
        ) {
          setValue("applications.0.department", "WomensInitative");
          setValue("applications.0.campaign", "Torat Imecha");

          watch(
            () => getValue("custom.sponsorshipType"),
            () => {
              if (isCustomContribution.value) return;
              if (getValue("custom.sponsorshipType") == "week") {
                setValue("amount", "1000");
                setValue("custom.dateOption", "Week");
              } else if (getValue("custom.sponsorshipType") == "month") {
                setValue("amount", "3600");
                setValue("custom.dateOption", "Month");
              } else if (getValue("custom.sponsorshipType") == "day") {
                setValue("amount", "250");
                setValue("custom.dateOption", "Day");
                // setValue("custom.seriesType", null);
              }
            }
          );
        } else if (getValue("custom.seriesType") == "Nach Yomi Daily Email") {
          setValue("custom.dailyEmail", "Nach Yomi Daily Email");
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "General Donation");
          setValue("custom.dafType", null);
          setValue("amount", "180");
          setValue("custom.dateOption", "Day");
          setValue("custom.sponsorshipType", "day");
          setValue("custom.programId", null);
        } else if (getValue("custom.seriesType") == "HaShoneh Halachos Daily Email") {
          setValue("custom.dailyEmail", "HaShoneh Halachos Daily Email");
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "General Donation");
          setValue("custom.dafType", null);
          setValue("amount", "180");
          setValue("custom.dateOption", "Day");
          setValue("custom.sponsorshipType", "day");
          setValue("custom.programId", null);
        } else if (getValue("custom.seriesType") == "Mishna Yomit Daily Email") {
          setValue("custom.dailyEmail", "Mishna Yomit Daily Email");
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "General Donation");
          setValue("custom.dafType", null);
          setValue("amount", "180");
          setValue("custom.dateOption", "Day");
          setValue("custom.sponsorshipType", "day");
          setValue("custom.programId", null);
        } else if (getValue("custom.seriesType") == "Shnayim Mikra Daily Email") {
          setValue("custom.dailyEmail", "Shnayim Mikra Daily Email");
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "General Donation");
          setValue("custom.dafType", null);
          setValue("amount", "180");
          setValue("custom.dateOption", "Day");
          setValue("custom.sponsorshipType", "day");
          setValue("custom.programId", null);
        } else {
          // setValue("amount", "250");
          setValue("custom.dailyEmail", null);
          setValue("applications.0.department", "OU_Torah");
          setValue("applications.0.campaign", "General Donation");
          setValue("custom.dafType", null);

          watch(
            () => getValue("custom.sponsorshipType"),
            () => {
              if (isCustomContribution.value) return;
              if (getValue("custom.sponsorshipType") == "week") {
                setValue("amount", "1000");
                setValue("custom.dateOption", "Week");
              } else if (getValue("custom.sponsorshipType") == "month") {
                setValue("amount", "3600");
                setValue("custom.dateOption", "Month");
              } else if (getValue("custom.sponsorshipType") == "day") {
                setValue("amount", "250");
                setValue("custom.dateOption", "Day");

                // setValue("custom.seriesType", null);
              } else {
                setValue("amount", "3600");
                setValue("custom.sponsorshipType", "month");
                setValue("custom.seriesType", "General Donation");
                setValue("custom.dateOption", "Month");
                setValue("custom.programId", null);
              }
            }
          );
        }
      }
    );

    onMounted(() => {
      fetch(
        process.env.NODE_ENV == "production"
          ? "https://outorah.org/allDonateSeries"
          : "https://outorah.oudev.org/allDonateSeries"
      )
        .then((x) => x.json())
        .then((x) => {
          series.value = x
            .filter((x: any) => x.allDafType != "Supplemental Clips")
            .map((item: any) => {
              let displayName = item.name;
              if (item.name === "Nach Yomi") displayName = "The OU's Shoshana Grossman Nach Yomi";
              if (item.name === "Torat Imecha Nach Yomi") displayName = "Torat Imecha Nach Yomi from the OU Women's Initiative";
              return { ...item, displayName };
            })
            .sort((a: any, b: any) => {
              if (a.name === "Torat Imecha Nach Yomi") return -1;
              if (b.name === "Torat Imecha Nach Yomi") return 1;
              return 0;
            });
        });
    });

    const selectedSeries = computed(() => {
      //@ts-ignore
      const foundSeries = series.value.find((x) => x.id == getValue("custom.programId"));

      //@ts-ignore
      if (foundSeries) return foundSeries.name;

      return null;
    });

    const params = queryParams();
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    watch(selectedSeries, (selectedSeries) => {
      if (isCustomContribution.value) return;
      setValue("applications.0.subCampaign", selectedSeries);
    });

    const seriesDisplayName = computed(() => {
      const type = getValue("custom.seriesType");
      const found = series.value.find((s: any) => s.name === type);
      return found?.displayName || type;
    });

    function setDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 6)
        ).toISOString()
      );
    }

    function setdayDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
        ).toISOString()
      );
    }

    function setMonthDate(date: Date) {
      //needs to be ipdated to first and end of month
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth() + 1, date.getDate())
        ).toISOString()
      );
    }
    return {
      setDate,
      setdayDate,
      setMonthDate,
      layout,
      getValue,
      setValue,
      series,
      seriesDisplayName,
      selectedSeries,
      submit,
      amudei,
      customPrograms,
      selectedCustomProgram,
      isCustomContribution,
      selectContributionType,
      selectCustomProgram,
      selectCustomProgramByValue,
      selectCustomProgramByEvent,
      form,
      isDev
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
background: none;
    box-shadow: none;
  font-size: 16px;
  color: #222;
  line-height: 1.4;
  font-family: "proxima-nova-condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep h2 {
  font-weight: 900;
  margin-bottom: 0;
  color: #365ba5;
  font-size: 20px;
  text-transform: capitalize;
  padding: 20px;
  margin-top: 0px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  // max-width: 29.666% !important;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}

// ::v-deep
//   .styled-radio--ou-donation.styled-radio
//   input[type="radio"]
//   + label[data-amount="72"] {
//   padding: 8px 0 !important;
//   display: block !important;
//   &:after {
//     content: "most popular choice";
//     font-size: 11px;
//     width: 100%;
//     display: block;
//     color: #666;
//     margin-top: 3px;
//   }
// }
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]:checked
  + label[data-amount="12"]:after {
  color: white;
}
// ::v-deep
//   .styled-radio--ou-donation.styled-radio
//   input[type="radio"]:not(:checked)
//   + label[data-amount="72"] {
//   background: #eee7fd;
// }
.tabs {
  display: flex;
  justify-content: center;
  .tab__link {
    border: none;
    background-color: #eee;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    flex: 1;
    text-align: center;
    font-size: 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    &.active {
      background: #365ba5;
      color: #fff;
    }
  }
}
.form-section {
  background: #f9f9f9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 15px;
  header {
    h4 {
      font-weight: 900;
      margin-bottom: 0px;
      color: #365ba5;
      margin-top: 0px;
      font-size: 20px;
      text-transform: capitalize;
      padding: 20px;
    }
    border-bottom: 1px solid #365ba5;
    margin-bottom: 20px;
  }
}

.form__field {
  padding: 20px;
}

.control-label {
  flex: 1;
  font-size: 14px;
  color: #222;
  max-width: 150px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}
.sub__label {
  font-weight: 200;
  font-size: 14px;
  display: block;
  margin-top: 3px;
  margin-bottom: 8px;
}
.contribution-type {
  display: flex;
  min-height: 68px;
  border: 1px solid #dedede;
  border-bottom: 1px solid #365ba5;
  border-radius: 10px 10px 0 0;
  background: #fff;
  overflow: hidden;

  label {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    margin: 0;
    padding: 16px 24px;
    color: #3650c9;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;

    &:has(input:checked) {
      color: #3845d2;
    }
  }

  input[type="radio"] {
    width: 22px;
    height: 22px;
    margin: 0;
    accent-color: #2586c4;
    cursor: pointer;
  }

  @media (max-width: 720px) {
    min-height: 0;

    label {
      gap: 8px;
      padding: 14px 14px;
      font-size: 15px;
    }

    input[type="radio"] {
      width: 18px;
      height: 18px;
      flex: 0 0 auto;
    }
  }
}
.custom-amount {
  margin-bottom: 20px;

  p {
    margin: 0 0 18px;
    font-size: 16px;
  }

  label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-right: 16px;
    cursor: pointer;
  }

  input[type="radio"] {
    accent-color: #1688c5;
  }

  input[type="number"] {
    width: 72px;
    border: 0;
    border-bottom: 1px solid #222;
    border-radius: 0;
    font-size: 16px;
  }

  @media (max-width: 720px) {
    label {
      margin-right: 12px;
      margin-bottom: 8px;
    }
  }
}
.program-designation-select {
  width: 100%;
  max-width: 420px;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #222;
  font-size: 16px;

  @media (max-width: 720px) {
    max-width: 100%;
  }
}
.series__type {
  width: 100%;
  margin-bottom: 20px;
  label {
    flex: 1;
  }
}
//type selector
.type-selector,
.main-selector {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // .radio-part {
  //   min-width: 33.333%;
  //   max-width: 33.333%;
  //   text-transform: uppercase;
  //   font-size: 13px;
  // }
}
.note {
  padding-top: 6px;
  font-style: italic;
  line-height: normal;
  font-size: 14px;
  font-weight: 200;
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}

.email__label {
  font-size: 14px;
  color: #222;
  max-width: 100%;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 9px;
  display: block;
}

.container.donation-torah{
  flex-flow: wrap;
  padding: 20px 10px;
  @media only screen and (min-width: 720px) {
    display: flex;
  }
}

.form-main {
  flex: 59%;
}
.form-sidebar {
  flex: 36%;
  @media only screen and (min-width: 720px) {
    margin-left: 5%;
  }
  font-size: 20px;
  .sidebar-sticky {
    @media only screen and (min-width: 720px) {
      position: sticky;
      top: 115px;
      right: 0;
    }
    .form-row.form-row--line{
      padding: 0px 20px 20px;
    margin: 0px;
    display: block;
    margin-right: 0px;
    max-width: 100%;
    }
    ul {
    margin-top: 10px;
    font-size: 18px;
    color: #6b6b6b;
    padding-left: 0px;
    margin-left: 0px;
    li {
      margin-bottom: 5px;
      font-size: 16px;
      span {
        color: black;
        font-size: 18px;
      }
    }
  }
   
  }

}
</style>